import {ScheduledTasksApi} from "../ScheduledTasksApi";
import {QueryKey, useQueryWrapper} from "./api-hooks-common";

export const useGetAirflowDagTaskInfos = (dagId: string) => useQueryWrapper([QueryKey.AIRFLOW_DAG_TASK_INFOS, dagId], () => ScheduledTasksApi.getAirflowTaskDataInfos(dagId));

export const useGetAirflowTaskHistories = (dagId: string, taskId: string) => useQueryWrapper([QueryKey.SCHEDULED_TASK_HISTORIES], () => ScheduledTasksApi.getAirflowTaskHistories(dagId, taskId));
